import { ComponentType } from 'react'
import { useRouter } from 'next/router'

import { useAuthContext } from '@/hooks/useAuthContext'
import { Loading } from '@/components/Loading'

export function withAuthProtection<T>(Component: ComponentType<T>) {
  return function AuthProtectionWrapper(props: T & ComponentType) {
    const { push, asPath: currentPathname } = useRouter()
    const { isAuthenticated, isFetched, isEmailVerified } = useAuthContext()

    if (!isFetched) {
      return <Loading />
    }

    if (!isAuthenticated && isFetched) {
      push({
        pathname: '/sign-in',
        query: {
          return_to: currentPathname,
        },
      })
    }

    if (isAuthenticated) {
      if (!isEmailVerified) {
        push({
          pathname: '/verification-required',
          query: {
            return_to: currentPathname,
          },
        })
      }
      return <Component {...props} />
    }
  }
}
